// extracted by mini-css-extract-plugin
export var infoIcon = "InfoIcon--infoIcon--qoldl";
export var infoIcon__trigger = "InfoIcon--infoIcon__trigger--woegA";
export var tkMyriadProSemiCondensed = "InfoIcon--tk-myriad-pro-semi-condensed--X-NTb";